export default __webpack_public_path__ + "static/media/Path -3@2x.2eece23d.png";